export default [
  {key: 1, label: "Emakeel"},
  {key: 2, label: "Väga hea"},
  {key: 3, label: "Rahuldav"},
  {key: 4, label: "Algtase"},
];
